module.exports = __webpack_public_path__ + "img/world.152bf615.png";